// arquivo user-data.js
function clearUserStorage() {
  localStorage.removeItem("loglevel:webpack-dev-server");
  localStorage.removeItem("token");
  localStorage.removeItem("id");
  localStorage.removeItem("type");
  localStorage.removeItem("type_name");
}

function parseJwt() {
  const token = localStorage.getItem("token");

  try {
    const decodedJwt = JSON.parse(atob(token.split(".")[1]));
    const currentDate = new Date();
    if (decodedJwt.exp * 1000 < currentDate) {
      return false;
    } else {
      return true;
    }
  } catch (e) {
    return null;
  }
}

export default { clearUserStorage, parseJwt };
